module.exports = __webpack_public_path__ + "static/media/block-chain.802c0b9a.png";